module.exports = __webpack_public_path__ + "img/20200704_215923.cc13cb0c.jpg";